import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import case_icon from "../../images/case_icon.png";
import history_icon from "../../images/history_taking_icon.png";
import diagnosis1_icon from "../../images/diagnosis_1_icon.png";
import exam_icon from "../../images/examination_icon.png";
import diagnosis2_icon from "../../images/diagnosis_2_icon.png";
import investigation_icon from "../../images/investigation_icon.png";
import evaluation_icon from "../../images/final_diagnosis_icon.png";
import management_icon from "../../images/management_icon.png";
import result_icon from "../../images/result_icon.png";
import { CustomIconButton, useWindowDimensions } from "./index";
import Grid from "@material-ui/core/Grid";
import {
  checkGameStatus,
  checkGameAwait,
  checkGamePage,
  checkGameIsAllowRevisit,
  navigateGameScreen,
  evaluateResult,
} from "../../service/logic";
import {
  clearGameState,
  setGameStatus,
  setGamePage,
  showModal,
} from "../../redux/dispatchers";
import { store } from "../../redux/store";
import flow_img from "../../images/flow_icon.png";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags";
import { GAME_STAGE } from "../../utils/constant";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    zIndex: 10,
    bottom: 20,
  },
  proceedButton: {
    position: "fixed",
    right: 50,
    [theme.breakpoints.down("sm")]: {
      right: 5,
    },
  },
  phoneroot: {
    position: "fixed",
    bottom: 20,
    zIndex: 10,
    width: "100vw",
  },
  navContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  collapseContainer: {
    marginLeft: 20,
    marginRight: 20,
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #C4C4C4",
    borderRadius: 10,
    padding: "0px 10px",
    marginBottom: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  disabled: {
    color: "#777777",
    cursor: "context-menu",
  },
  currentStage: {
    cursor: "pointer",
    fontSize: "18px",
    width: "65%",
    background: "#9F9F9F",
    borderRadius: 30,
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  selectedlistitem: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#c4bcbc",
    },
  },
  background: {
    position: "fixed",
    zIndex: 10,
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "black",
    opacity: "0.5",
    height: "100%",
  },
}));

const BottomNavBar = () => {
  const iconButtons = [
    {
      id: GAME_STAGE.PRESENTATION,
      page: "/presentation",
      image: case_icon,
      label: "Presentation",
    },
    {
      id: GAME_STAGE.HISTORY_TAKING,
      page: "/history",
      image: history_icon,
      label: "History Taking",
    },
    {
      id: GAME_STAGE.HISTORY_SUMMARY,
      page: "/historysummary",
      image: history_icon,
      label: "History Taking Evaluation",
    },
    {
      id: GAME_STAGE.DIAGNOSIS_1,
      page: "/diagnosis",
      image: diagnosis1_icon,
      label: "Diagnosis 1",
    },
    {
      id: GAME_STAGE.EXAMINATION,
      page: "/exam",
      image: exam_icon,
      label: "Examination",
    },
    {
      id: GAME_STAGE.EXAMINATION_EVALUATION,
      page: "/examevaluation",
      image: exam_icon,
      label: "Examination Evaluation",
    },
    {
      id: GAME_STAGE.DIAGNOSIS_2,
      page: "/diagnosis2",
      image: diagnosis2_icon,
      label: "Diagnosis 2",
    },
    {
      id: GAME_STAGE.INVESTIGATION,
      page: "/investigation",
      image: investigation_icon,
      label: "Investigation",
    },
    {
      id: GAME_STAGE.INVESTIGATION_EVALUATION,
      page: "/investigationevaluation",
      image: investigation_icon,
      label: "Investigation Evaluation",
    },
    {
      id: GAME_STAGE.FINAL_DIAGNOSIS,
      page: "/finaldiagnosis",
      image: evaluation_icon,
      label: "Final Diagnosis",
    },
    {
      id: GAME_STAGE.FINAL_DIAGNOSIS_EVALUATION,
      page: "/diagnosisevaluation",
      image: evaluation_icon,
      label: "Final Diagnosis Evaluation",
    },
    {
      id: GAME_STAGE.MANAGEMENT,
      page: "/management",
      image: management_icon,
      label: "Management",
    },
    {
      id: GAME_STAGE.MANAGEMENT_EVALUATION,
      page: "/managementevaluation",
      image: management_icon,
      label: "Management Evaluation",
    },
    {
      id: GAME_STAGE.FINAL_MARKS,
      page: "/finalmarks",
      image: result_icon,
      label: "Results",
    },
    {
      id: GAME_STAGE.CASE_SUMMARY,
      page: "/casesummary",
      image: result_icon,
      label: "Case Summary",
      display: "none",
    },
  ];

  const classes = useStyles();
  const { width } = useWindowDimensions();
  const isWidthSm = width <= 600;
  const isWidthMd = width <= 670;
  const isWidthLg = width >= 850;
  const [collapse, setCollapse] = useState(false);
  const [evaluated, setEvaluated] = useState(false);
  const onView = store.getState().gameStates.onViewStatus;
  const { role } = useSelector((state) => state.authDetails);

  const currentIndex = () => {
    for (let i = 0; i < iconButtons.length; i++) {
      if (checkGameStatus(iconButtons[i].id)) {
        return i;
      }
    }
    return null;
  };

  useEffect(() => {
    if (width > 600) {
      setCollapse(false);
    }
  }, [width]);

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  //currentIndex = current state when the user is not on the blank page
  //farthest = farthest state that the user has gone through
  //onView = latest state before going to blank page

  const navBlank = () => {
    if (currentIndex() !== null && !onView) {
      return iconButtons[currentIndex()].id;
    }
    if (onView) {
      return onView;
    }
  };

  const navPage = () => {
    if (currentIndex() !== null && !onView) {
      return iconButtons[currentIndex()].page;
    }
    if (onView) {
      return iconButtons[onView - 1].page;
    }
  };

  const showReminder = (status) => {
    setTimeout(() => {
      switch (status) {
        case 4: {
          showModal(
            "Short Note",
            `It is important to have a provisional diagnosis and differential diagnoses to guide you for further examination and investigation`,
            `Proceed`,
            null,
            () => {},
            null
          );
          break;
        }
        case 7: {
          showModal(
            "Short Note",
            `Based on your physical examination  findings, do you want to revise your provisional and differential diagnoses?`,
            `Yes, sure!`,
            null,
            () => {},
            null
          );
          break;
        }
        case 10: {
          showModal(
            "Short Note",
            `You have done your investigation in the previous stage. Now, let's move on to final diagnosis.`,
            `Proceed`,
            null,
            () => {},
            null
          );
          break;
        }
        default:
          return;
      }
    }, 300);
  };

  return (
    <>
      {isWidthSm ? (
        <>
          <div
            className={classes.background}
            style={{ display: collapse ? "block" : "none" }}
            onClick={() => {
              setCollapse(false);
            }}
          />
          <div
            className={classes.phoneroot}
            id="bottomNavDesktopRoot"
            style={{ zIndex: collapse ? "11" : "10" }}
          >
            <div className={classes.collapseContainer}>
              <Collapse in={collapse}>
                <List>
                  {iconButtons.map((content, index) =>
                    checkGameStatus(content.id) &&
                    content.id !== GAME_STAGE.CASE_SUMMARY ? (
                      <ListItem
                        key={content.id}
                        className={classes.selectedlistitem}
                        style={{
                          backgroundColor:
                            currentIndex() === index && !onView
                              ? "#9F9F9F"
                              : !!onView
                              ? index === onView - 1
                                ? "#9F9F9F"
                                : null
                              : null,
                        }}
                        onClick={() => {
                          setCollapse(false);
                          // if is already active, set to inactive
                          if (checkGamePage(content.page)) {
                            setGamePage("", content.id);
                          } else navigateGameScreen(content.id);
                        }}
                      >
                        {content.id === 1 ? (
                          <div className={classes.disabled}>
                            {content.label}
                          </div>
                        ) : (
                          <>
                            {content.label}
                            {currentIndex() === index && !onView ? (
                              <EmojiFlagsIcon style={{ marginLeft: 10 }} />
                            ) : !!onView ? (
                              index === onView - 1 ? (
                                <EmojiFlagsIcon style={{ marginLeft: 10 }} />
                              ) : null
                            ) : null}
                          </>
                        )}
                      </ListItem>
                    ) : (
                      <Fragment key={content.id} />
                    )
                  )}
                  {iconButtons.map((content) =>
                    checkGameAwait(content.id) ? (
                      <ListItem key={content.id}>
                        <div className={classes.disabled}>{content.label}</div>
                      </ListItem>
                    ) : (
                      <Fragment key={content.id} />
                    )
                  )}
                </List>
              </Collapse>
            </div>
            <div className={classes.navContainer}>
              <CustomIconButton
                image={flow_img}
                onClick={toggleCollapse}
                nav
                id="flow"
              />
              <div
                id="currentStage"
                className={classes.currentStage}
                onClick={() => {
                  let currentID = navBlank();
                  let currentPage = navPage();
                  if (checkGamePage(currentPage)) {
                    setGamePage("", currentID);
                  } else navigateGameScreen(currentID);
                }}
              >
                {currentIndex() !== null && !onView
                  ? iconButtons[currentIndex()].label
                  : !!onView
                  ? iconButtons[onView - 1].label
                  : null}
              </div>
              <div id="proceed">
                <CustomIconButton
                  Icon={NavigateNextIcon}
                  onClick={() => {
                    if (
                      store.getState().gameStates.status ===
                        GAME_STAGE.CASE_SUMMARY ||
                      store.getState().gameStates.status ===
                        GAME_STAGE.FINAL_MARKS
                    ) {
                      setGameStatus(14);
                      // reset game states after completing game
                      showModal(
                        "The Case is Completed",
                        `Are you sure to go back Case Selection page?`,
                        `Yes, proceed to Case Selection`,
                        `Hold on, stay on ${
                          iconButtons[store.getState().gameStates.status - 1]
                            .label
                        }`,
                        () => {
                          clearGameState();
                          navigateGameScreen(0);
                        },
                        null,
                        true
                      );
                    } else {
                      // back to latest or proceed
                      if (
                        store.getState().gameStates.status !==
                        store.getState().gameStates.onViewStatus
                      ) {
                        setGameStatus(store.getState().gameStates.status);
                      } else {
                        //request user confirmation before proceed
                        const nextStatus =
                          store.getState().gameStates.status + 1;
                        const currStatus = store.getState().gameStates.status;
                        const isAllowedRevisit = checkGameIsAllowRevisit(
                          currStatus
                        );
                        if (isAllowedRevisit) {
                          setGameStatus(nextStatus);
                          navigateGameScreen(0);
                        } else {
                          showModal(
                            "Proceed Confirmation",
                            `Are you sure you want to proceed? 
                              Take note that current stage cannot
                              be revisit again.`,
                            `Yes, proceed to ${
                              iconButtons[nextStatus - 1].label
                            }`,
                            `Hold on, stay on ${
                              iconButtons[currStatus - 1].label
                            }`,
                            () => {
                              setGameStatus(nextStatus);
                              navigateGameScreen(0);
                            }
                          );
                        }
                        showReminder(nextStatus);
                      }
                    }
                    navigateGameScreen(0);
                  }}
                  label="Continue"
                  proceed
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <Grid
          container
          className={classes.root}
          spacing={2}
          id="bottomNavDesktopRoot"
        >
          <Grid item xs={12}>
            <Grid
              container
              justify="center"
              spacing={isWidthLg ? 2 : isWidthMd ? 0 : 1}
            >
              {iconButtons.map((content) =>
                checkGameStatus(content.id) &&
                content.id !== GAME_STAGE.CASE_SUMMARY ? (
                  <Grid key={content.id} item>
                    {content.id === 1 ? (
                      <CustomIconButton
                        id={content.id}
                        image={content.image}
                        label={content.label}
                        disabled
                      />
                    ) : (
                      <CustomIconButton
                        id={content.id.toString()}
                        image={content.image}
                        onClick={() => {
                          // if is already active, set to inactive
                          if (checkGamePage(content.page)) {
                            setGamePage("", content.id);
                          } else navigateGameScreen(content.id);
                        }}
                        label={content.label}
                        active={checkGamePage(content.page)}
                      />
                    )}
                  </Grid>
                ) : (
                  <Fragment key={content.id} />
                )
              )}
              {iconButtons.map((content) =>
                checkGameAwait(content.id) ? (
                  <Grid key={content.id} item>
                    <CustomIconButton
                      id={content.id.toString()}
                      image={content.image}
                      label={content.label}
                      disabled
                    />
                  </Grid>
                ) : (
                  <Fragment key={content.id} />
                )
              )}
              <Grid item className={classes.proceedButton}>
                <CustomIconButton
                  id="proceed"
                  Icon={NavigateNextIcon}
                  onClick={() => {
                    if (
                      store.getState().gameStates.status ===
                        GAME_STAGE.CASE_SUMMARY ||
                      store.getState().gameStates.status ===
                        GAME_STAGE.FINAL_MARKS
                    ) {
                      setGameStatus(14);
                      // reset game states after completing game
                      showModal(
                        "The Case is Completed",
                        `Are you sure to go back Case Selection page?`,
                        `Yes, proceed to Case Selection`,
                        `Hold on, stay on ${
                          iconButtons[store.getState().gameStates.status - 1]
                            .label
                        }`,
                        () => {
                          // do not keep the results for non student
                          if (role !== "student" || evaluated) {
                            clearGameState();
                            navigateGameScreen(0);
                            return;
                          }
                          evaluateResult("", true).then(() => {
                            clearGameState();
                            navigateGameScreen(0);
                            setEvaluated(true);
                          });
                        }
                      );
                    } else {
                      // back to latest or proceed
                      if (
                        store.getState().gameStates.status !==
                        store.getState().gameStates.onViewStatus
                      ) {
                        setGameStatus(store.getState().gameStates.status);
                      } else {
                        //request user confirmation before proceed
                        const nextStatus =
                          store.getState().gameStates.status + 1;
                        const currStatus = store.getState().gameStates.status;
                        const isAllowedRevisit = checkGameIsAllowRevisit(
                          currStatus
                        );
                        if (isAllowedRevisit) {
                          setGameStatus(nextStatus);
                          navigateGameScreen(0);
                        } else {
                          showModal(
                            "Proceed Confirmation",
                            `Are you sure you want to proceed? 
                              Take note that current stage cannot
                              be revisit again.`,
                            `Yes, proceed to ${
                              iconButtons[nextStatus - 1].label
                            }`,
                            `Hold on, stay on ${
                              iconButtons[currStatus - 1].label
                            }`,
                            () => {
                              setGameStatus(nextStatus);
                              navigateGameScreen(0);
                            }
                          );
                        }
                        showReminder(nextStatus);
                      }
                    }
                    navigateGameScreen(0);
                  }}
                  label="Continue"
                  proceed
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default BottomNavBar;
